import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialFacebookWorkplaceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialFacebookWorkplace",
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.75 21.75c-.49.68-1.27 1.09-2.11 1.12-1.5 0-1.98-1.07-2.44-2.2l-2.25-5.51-2.24 5.51c-.39.94-.8 2.2-2.38 2.2s-2.07-1.27-2.45-2.2l-3.9-9.27h3.19l3.05 7.63 2.26-5.56c.36-.88.79-2.21 2.38-2.21s2.06 1.33 2.38 2.21l2.45 5.95a9.2 9.2 0 0 0 1.57-5.19c-.01-5.21-4.25-9.43-9.46-9.42a11.13 11.13 0 0 0-7.82 3.35c-4.32 4.39-4.26 11.46.13 15.77 2.84 2.79 6.96 3.86 10.8 2.8v2.95c-.99.21-2 .32-3.01.32-1.88 0-3.75-.37-5.49-1.1a14.14 14.14 0 0 1-7.48-7.44c-1.51-3.51-1.59-7.45 0-10.93 1.44-3.35 4.12-6.02 7.48-7.44 1.73-.73 3.6-1.1 5.48-1.1 6.8-.02 12.33 5.48 12.35 12.27v.01c.02 2.69-.85 5.32-2.48 7.46Z"
    })
  }));
};